import { Component, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import NiboWhatsAppConnection from '../../models/nibo-whatsapp-connection';
import { WhatsappSettingsService } from '../../services/whatsapp-settings.service';

@Component({
  standalone: false,
  selector: 'app-connection-screenshot',
  templateUrl: './connection-screenshot.component.html',
  styleUrls: ['./connection-screenshot.component.css']
})
export class ConnectionScreenshotComponent implements OnInit, OnDestroy {

  // Nao usamos bypassSecurityTrustUrl aqui: o sanitizer de URL do Angular aceita o
  // esquema `blob:` (so `javascript:` e bloqueado) e `img[src]` e contexto de URL,
  // entao a object URL passa pela sanitizacao normal. Alem disso, so criamos a object
  // URL depois de validar o content type e reescrevemos o blob com um tipo de imagem
  // da lista permitida -- assim um blob de HTML devolvido pelo backend nunca e
  // interpretado como conteudo ativo.
  private static readonly ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

  public readonly connection: NiboWhatsAppConnection;

  public readonly loading = signal(false);
  public readonly error = signal(false);
  public readonly imageUrl = signal<string | null>(null);

  private objectUrl: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { connection: NiboWhatsAppConnection },
    public dialogRef: MatDialogRef<ConnectionScreenshotComponent>,
    private readonly settingsService: WhatsappSettingsService
  ) {
    this.connection = data.connection;
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnDestroy(): void {
    this.revokeObjectUrl();
  }

  public load(): void {
    if (this.loading()) {
      return;
    }

    this.loading.set(true);
    this.error.set(false);
    this.revokeObjectUrl();
    this.imageUrl.set(null);

    this.settingsService.getObservabilityScreenshot(this.connection.connectionId)
      .pipe(take(1))
      .subscribe({
        next: (blob: Blob) => {
          const imageType = blob.type.split(';')[0].trim().toLowerCase();

          if (!ConnectionScreenshotComponent.ALLOWED_IMAGE_TYPES.includes(imageType)) {
            this.error.set(true);
            return;
          }

          this.objectUrl = URL.createObjectURL(blob.slice(0, blob.size, imageType));
          this.imageUrl.set(this.objectUrl);
        },
        error: () => {
          this.error.set(true);
        }
      }).add(() => {
        this.loading.set(false);
      });
  }

  public close(): void {
    this.dialogRef.close();
  }

  private revokeObjectUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }
}
